import {
  Radio as AntdRadio,
  RadioGroupProps as AntdRadioGroupProps,
} from "antd";
import { forwardRef } from "react";

interface AppRadioGroupProps extends Omit<AntdRadioGroupProps, "ref"> {
  // Add any additional custom props here if needed
}

/**
 * AppRadioGroup is a wrapper around Ant Design's Radio.Group component.
 *
 * @component
 * @example
 * <AppRadioGroup>
 *   <AppRadio value="a">A</AppRadio>
 *   <AppRadio value="b">B</AppRadio>
 * </AppRadioGroup>
 */
const AppRadioGroup = forwardRef<HTMLDivElement, AppRadioGroupProps>(
  (props, ref) => {
    return <AntdRadio.Group ref={ref} {...props} />;
  },
);

AppRadioGroup.displayName = "AppRadioGroup";

export default AppRadioGroup;
